import React, {useState} from 'react';
import {Box, HStack, Wrap, WrapItem} from '@chakra-ui/react';
import {TextG14} from '../../../components/typography';
import {PublicProfileAvailability} from '../../../hooks/usePublicProfile';
import {DAY_ABBREV} from '../../../utils/availability';

const GENERAL_LABELS: Record<string, {label: string; emoji: string}> = {
  weekday_mornings: {label: 'Weekday mornings', emoji: '🌅'},
  weekday_evenings: {label: 'Weekday evenings', emoji: '🏙️'},
  weekday_late: {label: 'Weekday late', emoji: '🌙'},
  weekend_mornings: {label: 'Weekend mornings', emoji: '🌄'},
  weekend_afternoons: {label: 'Weekend afternoons', emoji: '✨'},
  weekend_evenings: {label: 'Weekend evenings', emoji: '✨'},
};

const TIME_EMOJI: Record<string, string> = {
  Morning: '🌤️',
  Afternoon: '✨',
  Evening: '🏙️',
  morning: '🌤️',
  afternoon: '✨',
  evening: '🏙️',
};

const INITIAL_VISIBLE = 4;

interface AvailabilityChipsProps {
  availability: PublicProfileAvailability;
}

const AvailabilityChips = ({availability}: AvailabilityChipsProps) => {
  const [showAll, setShowAll] = useState(false);

  const chips: {label: string; emoji: string}[] = [];
  availability.general.forEach((id) => {
    const item = GENERAL_LABELS[id];
    if (item) chips.push(item);
  });
  Object.entries(availability.specific).forEach(([day, times]) => {
    const abbrev = DAY_ABBREV[day] || day;
    times.forEach((t) => {
      const emoji = TIME_EMOJI[t] || '✨';
      const label = `${abbrev} ${t.charAt(0).toUpperCase() + t.slice(1)}`;
      chips.push({label, emoji});
    });
  });

  if (chips.length === 0) return null;

  const visible = showAll ? chips : chips.slice(0, INITIAL_VISIBLE);
  const hiddenCount = chips.length - INITIAL_VISIBLE;

  return (
    <Box px={4} mb={6}>
      <TextG14 mt="0" fontWeight="700" mb={3}>
        I'm free to connect on...
      </TextG14>
      <Wrap spacing={2}>
        {visible.map((chip, i) => (
          <WrapItem key={i}>
            <HStack
              px={3}
              py={1.5}
              borderRadius="20px"
              border="1px solid #E5E5E5"
              bg="white"
              spacing={1.5}
              boxShadow="0 0 16px 0 rgba(0, 0, 0, 0.08)">
              <span style={{fontSize: '14px'}}>{chip.emoji}</span>
              <TextG14 mt="0">{chip.label}</TextG14>
            </HStack>
          </WrapItem>
        ))}
      </Wrap>
      {!showAll && hiddenCount > 0 && (
        <TextG14
          mt="12px"
          color="#1A1A1A"
          fontWeight="600"
          cursor="pointer"
          onClick={() => setShowAll(true)}>
          +{hiddenCount} more availability window{hiddenCount > 1 ? 's' : ''}
        </TextG14>
      )}
    </Box>
  );
};

export default AvailabilityChips;
